import type { HistoryState } from '@lexical/react/LexicalHistoryPlugin';
import type { EditorState, LexicalEditor } from 'lexical';

/**
 * 程序化重建编辑器内容后，重置 undo/redo 并把当前内容设为新的历史基线。
 * 这样后续第一次用户编辑仍可撤销回这次外部回填后的状态。
 */
export function resetHistoryState(
  historyState: HistoryState,
  editor: LexicalEditor,
  editorState?: EditorState,
) {
  const nextHistoryState = historyState;

  nextHistoryState.undoStack = [];
  nextHistoryState.redoStack = [];
  nextHistoryState.current = {
    editor,
    editorState: editorState || editor.getEditorState(),
  };
}
